<template>
    <div>
      <!-- <h2> {{ this.results.company }} |  {{ this.results.contractType }} | {{ this.results.workTime }} | {{ this.results.locations }} </h2> -->
      <h2> {{ this.headerFields }} </h2>
      <p v-if="salaryText" class="salary-line">{{ salaryText }}</p>
      <p v-if="showSalaryDetails" class="salary-line">{{ jobCountry === 'hungary' ? $t('salaryDetailsHungary') : $t('salaryDetails') }}</p>
    </div>
</template>
<script>

const CURRENCY_SYMBOLS = { EUR: '€', GBP: '£', USD: '$', CHF: 'CHF', SEK: 'kr', CZK: 'Kč', HUF: 'Ft', RON: 'lei' }

const PERIOD_KEYS = {
  'Per Month': 'salaryPeriodMonth',
  'Per Year': 'salaryPeriodYear',
  'Per Hour': 'salaryPeriodHour',
  'Per Week': 'salaryPeriodWeek',
  'Per Day': 'salaryPeriodDay',
}

export default {

computed: {

    companySpecificConfig() { return this.$store.state.companySpecificConfig },
    results() { return this.$store.state.results; },
    pickedLanguage() { return this.$store.state.pickedLanguage },
    jobCountry() { return (this.results.country || '').trim().toLowerCase() },

    // recieves the selected companyConfiguration from vuex and reads the subheaderConfig array
    //
    headerFields() {

        if (this.companySpecificConfig.subheaderConfig == undefined) { return '' }
        else {

        let finalString = ""
        let arrayCount = this.companySpecificConfig.subheaderConfig.length
        let iterationCount = 0


            this.companySpecificConfig.subheaderConfig.map( entry => {

                        // console.log(entry)


            if (entry == "company") {
                finalString += (this.results.company)
            }
            else if (entry == "contractType") {
                finalString += (this.results.contractType)
            }
            else if (entry == "workTime") {
                finalString += (this.results.workTime)
            }
            else if (entry == "locations") {
                finalString += (this.results.locations)
            }
            else if (entry == "workModel") {
                finalString += (this.results.workModel)
            }

            iterationCount += 1

            if (iterationCount != arrayCount) {
                finalString += ' | '
            }
            })

            return finalString

                }
            },

    salaryText() {
      if (this.jobCountry === 'czech republic') return null
      if (this.jobCountry === 'hungary') return null

      const pt = this.results.payTransparency
      if (!pt || !pt.displaySalaryInformation) return null
      if (!pt.salaryMin) return null

      const intlLocale = this.pickedLanguage.replace('_', '-')
      const fmt = (amount) => new Intl.NumberFormat(intlLocale, { maximumFractionDigits: 0 }).format(Number(amount))
      const symbol = CURRENCY_SYMBOLS[pt.currency] || pt.currency || ''
      const periodKey = PERIOD_KEYS[pt.salaryPeriod]
      const period = periodKey ? this.$t(periodKey) : (pt.salaryPeriod || '')

      if (pt.salaryMax) {
        return `${this.$t('salaryRange')}: ${fmt(pt.salaryMin)} – ${fmt(pt.salaryMax)} ${symbol} ${this.$t('salaryPer')} ${period}`
      }
      return `${this.$t('salaryStarting')}: ${fmt(pt.salaryMin)} ${symbol} ${this.$t('salaryPer')} ${period}`
    },

    showSalaryDetails() {
      if (this.jobCountry === 'czech republic') return false

      const pt = this.results.payTransparency
      if (!pt || !pt.displaySalaryInformation) return false

      if (this.jobCountry === 'hungary') return true
      return !!this.salaryText
    },
        },
    }
</script>

<style scoped>
.salary-line {
  font-size: 16px;
  font-weight: normal;
  line-height: 100%;
  margin: 0;
}
.salary-line:first-of-type {
  margin-top: 8px;
}
</style>